<!-- 底部导航栏 -->
<template>
  <div class="tabbar">
    <div class="tab-box">
      <div
        class="item"
        v-for="(item, index) in imgBoss"
        :key="index"
        @click="select(index,item.url,item.type)"
      >
        <img :src="item.img" class="tab-img" v-if="idx!=index" />
        <img :src="item.selectImg" class="tab-img" v-if="idx==index" />
        <span
          class="tab-text"
          :style="idx==index?'color:#FF4343;font-weight:bold':''"
        >{{item.title}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  components: {},
  data() {
    return {
      imgBoss: [
        {
          img: require("./img/unjobSearch.png"),
          selectImg: require("./img/jobSearch.png"),
          title: "求职管理",
          url: "HomeBoss",
          type: 0
        },
        {
          img: require("./img/unawesome.png"),
          selectImg: require("./img/awesome.png"),
          title: "牛人推荐",
          url: "Recommend",
          type: 1
        },
        {
          img: require("./img/unposition.png"),
          selectImg: require("./img/position.png"),
          title: "职位管理",
          url: "Ment"
        },
        {
          img: require("./img/unenterprise.png"),
          selectImg: require("./img/enterprise.png"),
          title: "企业中心",
          url: "Mine"
        }
      ]
    };
  },
  computed: {
    ...mapState(["idx"])
  },
  methods: {
    ...mapMutations(["SET_TABS"]),
    select(val, url, type) {
      var that = this;
      this.SET_TABS({
        index: val,
        type: type
      });
      that.$router.replace({
        name: url
      });
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang='less' scoped>
.tabbar {
  .tab-box {
    position: fixed;
    width: 100%;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    display: flex;
    align-items: center;
    box-shadow: 0.1rem 0 0.05rem rgba(0, 0, 0, 0.3);
    .item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 0.22rem 0;
      background: #fff;

      .tab-img {
        width: 0.48rem;
        height: 0.48rem;
      }
      .tab-text {
        font-size: 0.22rem;
        font-weight: 400;
        line-height: 0.33rem;
        color: rgba(179, 179, 179, 1);
        padding: 0.2rem 0 0;
      }
    }
  }
}
.tabbar::before {
  content: "";
  display: block;
  height: 1.45rem;
  width: 100%;
}
</style>